import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'om-den-tilskadekomne';
            break;
        case 'om-den-tilskadekomne':
            nextPage = isAddAnotherPersonChecked('injuredPersonAddMorePersons-1', formConfig, formValues)
                ? 'om-den-tilskadekomne-2'
                : 'dato';
            break;

        case 'om-den-tilskadekomne-2':
            nextPage = isAddAnotherPersonChecked('injuredPersonAddMorePersons-2', formConfig, formValues)
                ? 'om-den-tilskadekomne-3'
                : 'dato';
            break;
        case 'om-den-tilskadekomne-3':
            nextPage = isAddAnotherPersonChecked('injuredPersonAddMorePersons-3', formConfig, formValues)
                ? 'om-den-tilskadekomne-4'
                : 'dato';
            break;
        case 'om-den-tilskadekomne-4':
            nextPage = 'dato';
            break;

        case 'dato':
            nextPage = 'adresse';
            break;
        case 'adresse':
            nextPage = 'beskriv-skaden';
            break;
        case 'beskriv-skaden':
            nextPage = 'foer-skaden';
            break;
        case 'foer-skaden':
            nextPage = 'tilskadekomne-foer-skaden';
            break;
        case 'tilskadekomne-foer-skaden':
            nextPage = 'om-ansvar';
            break;
        case 'om-ansvar':
            nextPage = 'vidner';
            break;
        case 'vidner':
            nextPage = 'tingskade';
            break;
        case 'tingskade':
            nextPage = 'dokumentation';
            break;

        case 'dokumentation':
            nextPage = 'forsikringsmaegler';
            break;

        case 'forsikringsmaegler':
            nextPage = 'om-virksomheden';
            break;

        case 'om-virksomheden':
            nextPage = 'andet-selskab';
            break;

        case 'andet-selskab':
            if (getValueOrDefault(formConfig, formValues, 'duplicateInsuranceInOtherCompany').value === 'Yes') {
                return 'hvilket-selskab';
            }

            return 'om-dig';

        case 'hvilket-selskab':
            return 'om-dig';

        case 'om-dig':
            nextPage = 'resume';
            break;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};

/**
 * Determines if a given 'add another person' checkbox element is selected or not.
 * @param elementId Id of the 'add another person' checkbox element
 * @param formConfig
 * @param formValues
 * @returns True if the 'add another person' checkbox is selected, else false.
 */
const isAddAnotherPersonChecked = (elementId: string, formConfig: FormConfig, formValues: FormValues): boolean => {
    const addAnotherPersonCheckbox = getValueOrDefault(formConfig, formValues, elementId);
    return addAnotherPersonCheckbox && addAnotherPersonCheckbox.length > 0
        ? addAnotherPersonCheckbox[0].value === 'yes'
        : false;
};
